import { render } from "./ApplicationsComponent.vue?vue&type=template&id=ecb9b060"
import script from "./ApplicationsComponent.vue?vue&type=script&lang=js"
export * from "./ApplicationsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__